import { useVerifyProfile } from '@/providers/VerifyProfileProvider';
import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Group, Image, PinInput, Stack, Text, rem } from '@mantine/core';
import Link from 'next/link';
import classes from './AccountInfo.module.css';
export const InfoPhoneVerify: React.FC = () => {
  const {
    i18n
  } = useLingui();
  const {
    setVerify
  } = useVerifyProfile();
  const handleSuccess = () => {
    setVerify(true);
  };
  return <Stack align="center" gap={0}>
      <Image src="/assets/profile/phone_verify.svg" w={180} h={180} mb={36} mx="auto" />
      <Text fz={{
      base: rem(20),
      sm: rem(36),
      lg: rem(25)
    }} lh={rem(36)} className={gunterzBold.className} c="var(--text-prime)">
        {i18n._('Verification code')}
      </Text>
      <Text fz="xs" fw={700} tt="uppercase" mt={{
      sm: 12,
      lg: 0
    }} c="var(--text-dark)">
        {i18n._('Enter the code sent to ')}

        <Text span inherit c="var(--text-green)">
          {i18n._('123 445 6789')}
        </Text>
      </Text>

      <PinInput size="md" inputMode="numeric" placeholder="-" my={36} classNames={{
      input: classes.input
    }} onComplete={handleSuccess} />

      <Group fz="xs" fw={700} tt="uppercase" gap={4} wrap="nowrap">
        <Text inherit c="var(--text-dark)">
          {i18n._('Didn’t receive the verification code? ')}
        </Text>
        <Text inherit component={Link} href="#" td="underline" c="var(--text-blue)">
          {i18n._('send again')}
        </Text>
      </Group>
    </Stack>;
};